export default {
  name: "multilangmixin",
  
  //opzionale
  props:["lang"],

  data(){
    return {
          "currentlang":""
    }
  },
  

  created(){
      this.fnInitLang();
      //console.log("createdmixin ",this.$options.name, "lang: ",this.currentlang);  
    

  },

  methods: {


      fnGetTranslation(piLang,piKey)
      {
        if (window.$translations[piLang][piKey]==undefined)
        {
            return "key not found: "+piLang+":"+piKey;
        }
        else
        {
          return window.$translations[piLang][piKey];
        }
        
      },


      fnGetNextLang(){
        if (this.currentlang=="it")
        {
          return "en";
        }
        else
        {
          return "it";
        }

      },

      fnSwitchLang(piLang){
          //console.log("fnSwitchLang:", piLang);


          let wnewpath=window.location.pathname;
         
          //console.log(wnewpath.substring(0,3));
          //console.log(wnewpath.substring(3,wnewpath.length));

          wnewpath="/"+this.fnSanitazeLang(piLang)+wnewpath.substring(3,wnewpath.length);
          
          wnewpath=window.location.href.replace(window.location.pathname,wnewpath);
          
          window.location=wnewpath;
          //this.$router.push(wnewpath);


      },


      fnGetBrowserLang() {
        
        let wret="en";
        let wlang = navigator.language || navigator.userLanguage;
        if (wlang.search("it")!=-1)
        {
          wret="it";
        }
        
        return wret;
      },



      fnGetLangFromAddress()
      {
        let wret="";

        if (window.location.pathname.length>=4)
        {
          if ((window.location.pathname[0]=="/") && (window.location.pathname[3]=="/"))
          {
              wret=window.location.pathname.substring(1,3);            
          }
        }

        return wret;
      },
      
      fnGetQueryParam(piParam)
      {

        let wfind=-1;
        let wret="";

        let wquery=window.location.search.replace("?","");
        let wsplit = wquery.split("&");

        let i=0;
        while ((i<wsplit.length) && (wfind==-1))
        {
          let wsplitvalue = wsplit[i].split("=");
          if (wsplitvalue.length==2)
          {
            if (wsplitvalue[0].toLowerCase()==piParam.toLowerCase())
            {
              wret=wsplitvalue[1];
              wfind=i;
            }
          }
          i++;
        }


        return wret;

      },
      

      fnSanitazeLang(pilang)
      {
        let wret="en";
        if (pilang.toLowerCase()=="it")
        {
            wret="it"
        }
        return wret;
      },

      fnInitLang()
      {

        //console.log("initlang su :",this.$options.name);

        let wcurrentlang="";
        
        //console.log(window.location.search);
        let wquerylang=this.fnGetQueryParam("lang");

        //priorità lingue
        // 1 - su query string
        // 2 - su indirizzo /it/pagexxxxxxxx
        // 3 - su impostazioni browser
        

        if (wquerylang!="")
        { 
          //console.log("current lang da query");
          wcurrentlang=wquerylang;
        }
        else
        {
          let wlangfromaddress=this.fnGetLangFromAddress();
          if (wlangfromaddress!="")
          {
              //console.log("current lang da props");
              wcurrentlang=wlangfromaddress;
          }
          else
          {
              //console.log("current lang da browser");
              wcurrentlang=this.fnGetBrowserLang();
          }
        
        }
        
        this.currentlang=this.fnSanitazeLang(wcurrentlang);    
      
      
      }









    }
}